import {FC, CSSProperties } from 'react';
import { clx } from 'Utils';
import { LoadingMask, SkeletonWrapper } from 'Elements';
import styles from 'partials/feature/search/search-filter-box.module.scss';

interface Props {
	count?: string | number;
}

const Skeleton = ({ style }: { style: CSSProperties }) => {
	return (
		<div className="mb-5" style={style}>
			<LoadingMask
				className={clx(
					styles.loadingCol,
					styles.loadingMd,
					'mb-3 mt-1'
				)}
			/>
			<div className={styles.loadingRow}>
				<LoadingMask
					className={clx(styles.loadingCol, styles.loadingLg)}
				/>
			</div>
			<div className={styles.loadingRow}>
				<LoadingMask
					className={clx(styles.loadingCol, styles.loadingSm)}
				/>
				<LoadingMask
					className={clx(styles.loadingCol, styles.loadingLg)}
				/>
			</div>
			<div className={styles.loadingRow}>
				<LoadingMask
					className={clx(styles.loadingCol, styles.loadingSm)}
				/>
				<LoadingMask
					className={clx(styles.loadingCol, styles.loadingLg)}
				/>
			</div>
			<div className={styles.loadingRow}>
				<LoadingMask
					className={clx(styles.loadingCol, styles.loadingSm)}
				/>
				<LoadingMask
					className={clx(styles.loadingCol, styles.loadingLg)}
				/>
			</div>
			<div className={styles.loadingRow}>
				<LoadingMask
					className={clx(styles.loadingCol, styles.loadingSm)}
				/>
				<LoadingMask
					className={clx(styles.loadingCol, styles.loadingLg)}
				/>
			</div>
		</div>
	);
};

export const SearchFilterLoading: FC<Props> = ({ count = 4 }) => {
	return <SkeletonWrapper skeleton={Skeleton} count={count} />;
};

SearchFilterLoading.displayName = 'SearchFilterLoading';
